module.exports = __webpack_public_path__ + "media/images/where-assets-icon-fire-e36f0c2e46ca81aa1eb66f974c690d01.svg";